<template>
    <div>
      <div class="col-lg-12" style="padding-top: 20px; padding-bottom: 20px">
        <div class="row">
          <div class="col-lg-4">
            <el-select
              placeholder="Select customer"
              v-model="selects.assigner"
              @change="getAssigner()"
              filterable
            >
              <el-option
                v-for="option in selects.assigners"
                class="select-info custom-option"
                :value="option.value"
                :label="option.label"
                :key="option.value"
              ></el-option>
            </el-select>
            &nbsp;
            <el-select
              placeholder="Select type"
              v-model="selects.type"
              @change="getType()"
              filterable
            >
              <el-option
                v-for="option in selects.types"
                class="select-info custom-option"
                :value="option.value"
                :label="option.label"
                :key="option.value"
              ></el-option>
            </el-select>
          </div>
          <div class="col-lg"></div>
          <div class="col-lg-2">
            <!-- <base-input> -->
              <el-input
                type="search"
                class="mb-3 search-input"
                
                prefix-icon="el-icon-search"
                placeholder="Search Job, Cust..."
                v-model="searchQuery"
                aria-controls="datatables"
              ></el-input>
            <!-- </base-input> -->
          </div>
        </div>
      </div>
  
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-12">
              <div id="tableku" v-if="this.load == false">
                <el-table
                  :data="queriedData"
                  style="width: 100%"
                  height="350"
                  :header-cell-style="{
                    background: 'transparent',
                    color: 'gray',
                  }"
                  class="custom-table"
                >
                  <el-table-column
                    :min-width="200"
                    align="center"
                    prop="jobno"
                    label="REFERENCE NO"
                  >
                    <div slot-scope="{ row }">
                      <p class="job-no-title" style="color: #358CCB" @click="getJobPage()">
                        {{ row.jobno }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column
                    :min-width="200"
                    sortable
                    align="center"
                    prop="datecreated"
                    label="DATE CREATED"
                  ></el-table-column>
                  <el-table-column
                    :min-width="200"
                    align="center"
                    prop="quotation"
                    label="QUOTATION"
                  >
                    <div slot-scope="{ row }">
                      <p
                        style="color: #0BAA00"
                        v-if="row.quotation == 'Complete'"
                      >
                        {{ row.quotation }}
                      </p>
                      <p
                        style="color: #FFA827"
                        v-if="row.quotation == 'Ready to Review'"
                      >
                        {{ row.quotation }}
                      </p>
                    </div></el-table-column
                  >
                  <el-table-column
                    v-for="column in joblist"
                    :key="column.label"
                    :prop="column.prop"
                    :label="column.label"
                    align="center"
                    :min-width="200"
                  >
                  </el-table-column>
                  <el-table-column
                    :min-width="200"
                    align="center"
                    prop="invoice"
                    label="INVOICE"
                  >
                    <div slot-scope="{ row }">
                      <p style="color: #0BAA00" v-if="row.invoice == 'Complete'">
                        {{ row.invoice }}
                      </p>
                      <p style="color: #EC1B23" v-if="row.invoice == 'Pending'">
                        {{ row.invoice }}
                      </p>
                      <p style="color: #A5A5A5" v-if="row.invoice != 'Pending' && row.invoice != 'Complete'">{{ row.invoice }}</p>
                    </div>
                  </el-table-column>
                  <el-table-column
                    :min-width="200"
                    align="center"
                    prop="cn"
                    label="CN"
                  >
                    <div slot-scope="{ row }">
                      <p
                        style="color: #0BAA00"
                        v-if="row.cn == 'Complete'"
                      >
                        {{ row.cn }}
                      </p>
                      <p
                        style="color: #EC1B23"
                        v-if="row.cn == 'Pending'"
                      >
                        {{ row.cn }}
                      </p>
                    </div></el-table-column
                  >
                  <el-table-column
                    :min-width="200"
                    align="center"
                    prop="wdr"
                    label="WDR"
                  >
                    <div slot-scope="{ row }">
                      <p style="color: #0BAA00" v-if="row.wdr == 'Complete'">
                        {{ row.wdr }}
                      </p>
                      <p style="color: #EC1B23" v-if="row.wdr == 'Pending'">
                        {{ row.wdr }}
                      </p>
                      <p style="color: #A5A5A5" v-if="row.wdr != 'Pending' && row.wdr != 'Complete'">{{ row.wdr }}</p>
                    </div>
                  </el-table-column>
                  <el-table-column
                    :min-width="200"
                    align="center"
                    prop="waste"
                    label="WASTE INVENTORY LOCATION"
                  >
                    <div slot-scope="{ row }">
                      <p style="color: #0BAA00" v-if="row.waste == 'Complete'">
                        {{ row.waste }}
                      </p>
                      <p style="color: #EC1B23" v-if="row.waste == 'Pending'">
                        {{ row.waste }}
                      </p>
                      <p style="color: #A5A5A5" v-if="row.waste != 'Pending' && row.waste != 'Complete'">{{ row.waste }}</p>
                    </div>
                  </el-table-column>
                  <el-table-column
                    :min-width="200"
                    align="center"
                    prop="labreport"
                    label="LAB REPORT"
                  >
                    <div slot-scope="{ row }">
                      <p style="color: #0BAA00" v-if="row.labreport == 'Complete'">
                        {{ row.labreport }}
                      </p>
                      <p style="color: #EC1B23" v-if="row.labreport == 'Pending'">
                        {{ row.labreport }}
                      </p>
                      <p style="color: #A5A5A5" v-if="row.labreport != 'Pending' && row.labreport != 'Complete'">{{ row.labreport }}</p>
                    </div>
                  </el-table-column>
                  
                  
                </el-table>
              </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import {
    Alert,
    Select,
    Option,
    DatePicker,
    Table,
    TableColumn,
  } from "element-ui";
  import swal from "sweetalert2";
  import { Circle8 } from "vue-loading-spinner";
  import util from "../../../util/util";
  import Card from "../../../components/Cards/Card.vue";
  import {
    Modal,
    ImageUpload,
    BasePagination,
    BaseSwitch,
  } from "../../../../src/components";
  import moment from "moment";
  import Fuse from "fuse.js";
  import { debounce } from "src/util/debounce";
  
  export default {
    name: "InventoryList",
  
    components: {
      Card,
      Modal,
      ImageUpload,
      [DatePicker.name]: DatePicker,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      BasePagination,
      BaseSwitch,
      Circle8,
      [Select.name]: Select,
      [Option.name]: Option,
    },
  
    data() {
      return {
        selectedFileName: "",
        allfilename: [],
        tableDatas: [
          {
            jobno: "NPV211028002",
            datecreated: "14 Nov 2023",
            quotation: "Ready to Review",
            collectiondate: "15 Nov 2023",
            invoice: "Complete",
            cn: "Complete",
            wdr: "-",
            waste: "-",
            labreport: "-",
          },
          {
            jobno: "NPV211028002",
            datecreated: "14 Nov 2023",
            quotation: 'Complete',
            collectiondate: "14 Nov 2023",
            invoice: "Pending",
            cn: "Complete",
            wdr: "-",
            waste: "In PRF",
            labreport: "Complete",
          },
          {
            jobno: "NPV211028002",
            datecreated: "14 Nov 2023",
            quotation: 'Complete',
            collectiondate: "14 Nov 2023",
            invoice: "-",
            cn: "Pending",
            wdr: "Complete",
            waste: "In PRF",
            labreport: "N/A",
          },
          {
            jobno: "NPV211028002",
            datecreated: "14 Nov 2023",
            quotation: 'Complete',
            collectiondate: "14 Nov 2023",
            invoice: "-",
            cn: "Complete",
            wdr: "Pending",
            waste: "In PRF",
            labreport: "N/A",
          },
          {
            jobno: "NPV211028002",
            datecreated: "14 Nov 2023",
            quotation: 'Complete',
            collectiondate: "14 Nov 2023",
            invoice: "-",
            cn: "Pending",
            wdr: "-",
            waste: "In PRF",
            labreport: "Pending",
          },
          {
            jobno: "NPV211028002",
            datecreated: "14 Nov 2023",
            quotation: 'Ready to Review',
            collectiondate: "14 Nov 2023",
            invoice: "-",
            cn: "Complete",
            wdr: "-",
            waste: "In PRF",
            labreport: "N/A",
          },
        ],
  
        load: false,
  
        jobno: [
          {
            prop: "jobno",
            label: "REFERENCE NO",
          },
        ],
        joblist: [
          {
            prop: "collectiondate",
            label: "COLLECTION DATE",
          },
        ],
  
        selects: {
          assigner: "",
          assigners: [
            { value: "00", label: "All" },
            { value: "01", label: "Yahya Abd Rahman" },
            { value: "02", label: "Ikhwan Ayub" },
            { value: "03", label: "Haziq Haikal" },
          ],

          type: "",
          types: [
            { value: "00", label: "All" },
            { value: "01", label: "Waste" },
            { value: "02", label: "Product" },
          ],
        },
  
        temp: [],
        searchQuery: "",
        searchedData: [],
        fuseSearch: null,
        currentRow: "",
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0,
        },
      };
    },
    methods: {
      getJobPage() {
        this.$router.push("/JobPage");
      },
  
      getData() {
        // this.tableDatas = [];
  
        // var obj = {
        //   jobno: "hi",
        //   customer: "hello",
        // };
  
        // this.tableDatas.push(obj);
        this.temp.push(this.tableDatas);
      },
    },
    created() {
      this.getData();
    },
    computed: {
      queriedData() {
        let result = this.tableDatas;
        if (this.searchedData.length > 0) {
          result = this.searchedData;
        }
        return result.slice(this.from, this.to);
      },
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
      total() {
        return this.searchedData.length > 0
          ? this.searchedData.length
          : this.tableDatas.length;
      },
    },
    watch: {
      searchQuery: debounce(function (search) {
        console.log(search);
        if (search != "") {
          this.tableDatas = this.temp.filter((value) =>
            value.jobno.toLowerCase().includes(search.toLowerCase())
          );
        } else {
          this.tableDatas = this.temp;
        }
      }, 500),
    },
    mounted() {
      this.fuseSearch = new Fuse(this.tableDatas, {
        keys: ["jobno"],
        threshold: 1.0,
      });
    },
  };
  </script>
  <style>
  .custom-button {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid lightgray;
  }
  
  .custom-dropdown .el-select-dropdown {
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  .job-no-title {
  color: #358CCB;
  text-decoration: none;
}
.job-no-title:hover {
  color: #358CCB;
  text-decoration: underline;
  cursor: pointer;
}
  </style>
  